
























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { InputResponse } from '@/constants/form/types';

@Component({})
export default class Tree extends Vue {
  // ツリービュー要素
  @Prop({ default: () => [] })
  items?: Array<{ [k: string]: string }>;

  // ツリービュー子要素名
  @Prop({ default: 'id' })
  itemKey?: string;
  // ツリービュー子要素名
  @Prop({ default: 'name' })
  itemText?: string;
  // ツリービュー子要素名
  @Prop({ default: 'childGroups' })
  itemChildren?: string;
  // 選択時のアクティブ表示
  @Prop({ default: true })
  activatable?: boolean;
  // 初期表示でツリーをオープン表示
  @Prop({ default: true })
  openAll?: boolean;

  /**
   * 親コンポーネントに入力値を通知する
   * @module catchTreeInput
   * @return InputResponse - 名前と入力値
   */
  @Emit('catchTreeInput')
  public catchTreeInput(data: any): InputResponse {
    return data;
  }
}
